'use strict';

import {
    assignDeep,
    Buildings, components,
    globalTextures, isDesktop, isIOS,
    isMobile,
    isTablet, isWeb,
    projectMode, resourcesFolder,
    settingsData,
    threeJsVariables,
} from '../../settings';
import {
    captureError,
    clamp,
    getFileExtension,
    getUrlParam, getUrlSearchQuery,
    isNumeric,
    isOneMesh,
    lazyLoadingAll,
    plugTexture,
} from '../../functions';
import {
    bundle_initAutoBuildingsScript,
    initAutoBuildingsScript,
    loadBuildingModelsFromAzure,
    loadModelTexturesFromAzure,
} from './autoBuildingFunctions';
import {
    bundle_initAutoHighlightsScript,
    getHighlights,
    initAutoHighlightsScript,
    loadHighlightsModelFromAzure,
    setHighlights,
    setProjectSettings,
} from './autoSelectionBoxes';
import {
    getAmenities,
    getCommonAssets,
    getCrmData,
    getDictionary,
    getProps,
    getSettings,
    getSpecifications,
    sendLogs
} from '../crm/crm-requests';
import {
    basic_tile,
    environmentToggle,
    loadTilesEnvironment,
    setColorGamma,
    setDefaultTileMaterial,
    setFog,
    setHMap, setTilesShadowParams,
} from './environment';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { intro } from './camera';
import { EnvironmentToggle, prepareSphere } from './sceneBackground';
import { getDreamsSliderScope, removePreloader } from '../components/preloader/preloader';
import {
    addSceneObjects,
    hideSceneObjects,
    removeObjectsFromScene,
    sceneObjectsGroup,
    showSceneObjects,
} from '../points/points';
import {
    ClampToEdgeWrapping,
    CustomToneMapping,
    Data3DTexture,
    DoubleSide,
    EquirectangularReflectionMapping,
    Group,
    InstancedMesh,
    LinearFilter,
    LinearMipmapLinearFilter, LinearSRGBColorSpace,
    Matrix4,
    MeshBasicMaterial,
    MeshPhongMaterial, MeshPhysicalMaterial,
    MeshStandardMaterial, NearestFilter, NeutralToneMapping, Plane, PointsMaterial,
    RepeatWrapping,
    RGBAFormat, ShaderChunk, SRGBColorSpace, TextureLoader,
    UnsignedByteType,
    UVMapping, Vector2, Vector3,
} from 'three';
import { Cylinder } from '../mode/cylinder';
import { FloorPlan } from '../mode/floorPlan';
import { bundleSetSun, prepareLight, updateShadowMap } from './lights';
import { LiteMode } from '../mode/liteMode';
import { AutoExposure, setAnimations, setBokeh, setLut } from '../post-processing/post-processing';
import { fullClone } from '../threejs/threejs-components';
import { OrbitDayAndNight } from '../liveAnimations/DayNight/OrbitDayAndNight';
import { Cloudflare } from '../api/Cloudflare';
import { ColorCorrection } from './colorCorrection';
import { Loader } from './loader/Loader';
import { renderUpdateValuesOnDemand} from '../../app';
import { LUT } from '../post-processing/Passes/LUT';
import { AnimateObject } from '../liveAnimations/AnimateObject';
import { OptimizationTask } from '../gui/FPS';
import {Hmap} from './Hmap';
import { Environment } from '../components/Environment/Environment';
import { InstanceLOD } from './InstanceLOD/InstanceLOD';
import {ProjectLogs} from "../components/ProjectLogs";
import { DisplacementMaterial } from './Materials/DisplacementMaterial';
import {  ViewMode } from '../../common';
import { UpdateTask } from '../gui/LoaderTask';
import { InteriorMaterial } from './Materials/InteriorMaterial';
import { SeaMaterial } from './Materials/SeaMaterial';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import {MobileSearch} from "../menu/search/MobileSearch/MobileSearch";
import {
    setOrbitControls,
    setPanLimits,
    setPolarAngle,
    setViewDeviceTargetAndPosition,
} from '../controls/orbitControls';
import { BmbyMode } from '../mode/BmbyMode';
import { enterToTheBuildingWithMaxAvailableApartments } from '../components/building-switch/building_switch';
import { getVars } from '../customStyles/customStyles';
import { rightNavigationBar } from '../menu/navigation/right-nav-bar';
import { setInitialHtmlDirection } from '../components/langSwitcher/langSwitcher';
import { addBuildingsIntersections } from '../poi/poiCss';
import { Objects } from './Objects/Objects';
import {FutureDevelopment} from "../components/futureDevelopment/FutureDevelopment";
import { FluffyMaterial } from './Materials/FluffyMaterial';
import { QA } from '../qa/QA';
import { LayerMaterial } from './Materials/LayerMaterial';
import {Pagination} from "../components/pagination/Pagination";
import { prepareObjectsToDisappear } from '../components/Disappear/Disappear';
import { CameraCollision } from './CameraCollision';
import { AdditionalStandardMaterial } from './Materials/AdditionalStandardMaterial';
import { AirMode } from '../mode/AirMode';

const MODELS_TYPE_BUILDING       = 0
const MODELS_TYPE_SEL_BOX 	     = 1
const MODELS_TYPE_SCENE_OBJ      = 2
const MODELS_TYPE_SCENE_OBJ_TREE = 3

const multiTextures = {};
export const bundleTextures = {}
const bundleTexturesPMREMGenerated = {}
const bundleMaterials = {}
const bundleAnimations = {}
let _bundleTextures_counter = 0
const _tlLoader = new TextureLoader();
const hdrLoader = new RGBELoader();


export const setCoordinates = (obj,config)=>{
    if (obj) {
        obj.position.set(config.position[0],config.position[1],config.position[2])
        obj.rotation.set(config.rotation[0],config.rotation[1],config.rotation[2])
        obj.scale.set(config.scale[0],config.scale[1],config.scale[2])
    }
}

// const bundleTexturesLoaded = (t)=>{
//     _bundleTextures_counter = _bundleTextures_counter - 1
//     if (_bundleTextures_counter!==0){
//         return
//     }
//
//     // threeJsVariables.renderer.initTexture(t);
//     // генерируем envMap
//     for (let link in bundleTextures){
//         const t = bundleTextures[link]
//         if (t.name==='envMap'){
//             let _t = threeJsVariables.pmremgenerator.fromEquirectangular(t).texture
//             bundleTexturesPMREMGenerated[link] = _t
//         }
//     }
//
//     // заменяем envMap на сгенерированные
//     for (let materialName in bundleMaterials){
//         let material = bundleMaterials[materialName]
//         if (material.envMap!==null){
//
//             for (let link in bundleTextures){
//                 const t = bundleTextures[link]
//                 if (t===material.envMap){
//                     material.envMap = bundleTexturesPMREMGenerated[link]
//                 }
//             }
//
//         }
//     }
//
// }

const bundlePrepareMaterials = (bundleConfig,loader)=>{

    let listMap;

    if (OrbitDayAndNight.isActive) {
        listMap = ['map','normalMap','aoMap','roughnessMap','metalnessMap','envMap'];
    } else {
        listMap = ['map','normalMap','aoMap','roughnessMap','metalnessMap','envMap','lightMap']
    }

    const listValue = ['roughness','metalness','aoMapIntensity','envMapIntensity','lightMapIntensity','alphaTest']
    // TODO cdnRepository, projectFolder -> bundle
    const url = `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/building/`;
    //
    for (let modelName in bundleConfig.models) {
        let model = bundleConfig.models[modelName]

        let m = null
        switch(model.type){
            case MODELS_TYPE_SCENE_OBJ:
            case MODELS_TYPE_BUILDING:{
                m = new MeshStandardMaterial()
                m.transparent = true

                listMap.forEach(name=>{
                    if (model[name]===''){
                        return
                    }

                    let link = Cloudflare.resize(url + model[name]);
                    let t = bundleTextures[link]
                    if (t===undefined){
                        // _bundleTextures_counter = _bundleTextures_counter + 1
                        // t = loader.load(link,bundleTexturesLoaded)
                        t = loader.load(link,loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
                        // t = loader.load(link);
                        bundleTextures[link] = t
                    }
                    if (t.name===''){
                        t.name = name
                    }

                    switch (name) {
                        case 'envMap':
                            t.mapping = EquirectangularReflectionMapping;
                            break;
                        case 'aoMap':
                        case 'lightMap':
                            t.mapping = UVMapping;
                            t.channel = 1;
                            break;
                        default:
                            t.mapping = UVMapping;
                            break;
                    }

                    t.name = name;
                    t.colorSpace = LinearSRGBColorSpace;
                    t.wrapS = RepeatWrapping;
                    t.wrapT = RepeatWrapping;
                    t.offset.set(0,0);
                    t.repeat.set(1,1);

                    t.anisotropy = 2
                    t.magFilter = LinearFilter
                    t.minFilter = LinearMipmapLinearFilter

                    m[name] = t
                })

                listValue.forEach(name=>{
                    m[name] = parseFloat(model[name])
                    if (name === 'lightMapIntensity') {
                        m[name] *= Math.PI;
                    }
                })

                if (model.alphaTest!==0){
                    m.side = DoubleSide
                }
            }
            break;
            case MODELS_TYPE_SEL_BOX:{
                m = new MeshBasicMaterial()
            }
            break;
            case MODELS_TYPE_SCENE_OBJ_TREE:{

                m = new MeshStandardMaterial()

                m.side = DoubleSide
                m.transparent = true

                listMap.forEach(name=>{
                    if (model[name]===''){
                        return
                    }
                    let link = Cloudflare.resize(url + model[name]);
                    let t = bundleTextures[link]
                    if (t===undefined){
                        // _bundleTextures_counter = _bundleTextures_counter + 1
                        // t = loader.load(link,bundleTexturesLoaded)
                        t = loader.load(link,loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
                        // t = loader.load(link);
                        bundleTextures[link] = t
                    }
                    if (t.name===''){
                        t.name = name
                    }


                    switch (name) {
                        case 'envMap':
                            t.mapping = EquirectangularReflectionMapping;
                            break;
                        case 'aoMap':
                        case 'lightMap':
                            t.mapping = UVMapping;
                            t.channel = 1;
                            break;
                        default:
                            t.mapping = UVMapping;
                            break;
                    }

                    t.colorSpace = LinearSRGBColorSpace;
                    t.wrapS = RepeatWrapping;
                    t.wrapT = RepeatWrapping;
                    t.offset.set(0,0);
                    t.repeat.set(1,1);

                    t.anisotropy = 2
                    t.magFilter = LinearFilter
                    t.minFilter = LinearMipmapLinearFilter

                    m[name] = t
                })

                listValue.forEach(name=>{
                    m[name] = parseFloat(model[name])
                    if (name === 'lightMapIntensity') {
                        m[name] *= Math.PI;
                    }
                })

            }
            break;
        }

        bundleMaterials[modelName] = m

    }
}

const bundlePrepareBuildings = (bundleConfig,gltf,projectGroup)=>{
    // buildings coordinates
    setCoordinates(projectGroup,bundleConfig.building)

    for (let name in bundleConfig.models){
        const model = bundleConfig.models[name]
        if (model.type!==MODELS_TYPE_BUILDING){
            continue
        }

        const material = bundleMaterials[name]

        const building = gltf.scene.children.find(e=>e.name===name)
        if (!building){
            continue
        }
        const group = bundle_initAutoBuildingsScript(projectGroup,building,[])

        fixModelUV(group,material);

        group.traverse(o=>{
            if (o.material){
                o.material = material
                o.castShadow = true
                o.receiveShadow = true
            }
        })
    }
}

const bundlePrepareAnimationList = (bundleConfig,gltf)=>{
    for (let i=0;i<gltf.animations.length;i++){
        let a = gltf.animations[i]
        let name = a.name.split(':')
        name = name[0].replaceAll('.','')
        bundleAnimations[name]=[a]
    }
}

const bundlePrepareSceneObjects = (bundleConfig,gltf,projectGroup)=>{
    let id = 0
    const colors = new ColorCorrection().getColors('buildings');
    for (let i=0;i<bundleConfig.objs.length;i++){
        const o = bundleConfig.objs[i]
        let modelName = o.model.replaceAll('.','')
        const model = gltf.scene.children.find(e=>e.name===modelName)
        if (!model){
            continue
        }

        let c = new Group()
        const m = fullClone(model)
     	  c.add(m)
		    c.name = 'obj_'+id+'-'+m.name
        id = id + 1
        const material = bundleMaterials[o.model]
        fixModelUV(m,material);

        m.traverse(e=>{
            if (e.material){
                e.material = material
                e.material.color.setStyle(colors.color,LinearSRGBColorSpace);
                e.material.emissive.setStyle(colors.emissive,LinearSRGBColorSpace);
                e.castShadow = true
                e.receiveShadow = true
                threeJsVariables.sceneObjectsSlicer.add(e);
            }
        })

        setCoordinates(c,o)
        sceneObjectsGroup.add(c)
        let animations = bundleAnimations[model.name]
        if (animations && animations.length!==0){
            setAnimations(m,animations)
        }

    }

    if (sceneObjectsGroup.children.length!==0){
        threeJsVariables.scene.add(sceneObjectsGroup);
        threeJsVariables.renderList.reorder();

        // if (config.resources.sceneObjects.order === 0) {
        //     let indA = threeJsVariables.scene.children.indexOf(sceneObjectsGroup);
        //     let indB = threeJsVariables.scene.children.indexOf(projectGroup);
        //     threeJsVariables.scene.children[indB] = sceneObjectsGroup;
        //     threeJsVariables.scene.children[indA] = projectGroup;
        // }
    }
}

const bundlePrepareFog = (bundleConfig)=>{
    const fogColor = '#'+bundleConfig.fog.color;
    const fogDensity = parseFloat(bundleConfig.fog.density);
    threeJsVariables.scene.fog.color.setStyle(fogColor,LinearSRGBColorSpace);
    threeJsVariables.scene.fog.density = fogDensity;
    setFog(fogColor,fogDensity);

    if (!OrbitDayAndNight.isActive) {
        threeJsVariables.background.traverse(o=>{
            if (o.material){
                o.material.uniforms.fogColor.value.set(fogColor);
                o.material.uniforms.fogDensity.value = fogDensity;
            }
        })
    }
}

const bundlePrepareSphere = (bundleConfig)=>{
    if (BmbyMode.active)
        return;
    const lut = LUT.getScope('background');
    if (lut && threeJsVariables.background) {
        threeJsVariables.background.traverse(el => {
            if (el.isMesh) {
                lut.include(el.material);
            }
        });
    }

    if (bundleConfig.sphere.type === 'projection' && config.resources.background?.type === 'projection') {
        const projection = bundleConfig.sphere.projection;
        if (projection) {
            threeJsVariables.background.children[0].radius = projection.radius;
            threeJsVariables.background.children[0].height = projection.height;
        }
    }

    setCoordinates(threeJsVariables.background,bundleConfig.sphere)
    config.resources.background.position.x = bundleConfig.sphere.position[0]
    config.resources.background.position.y = bundleConfig.sphere.position[1]
    config.resources.background.position.z = bundleConfig.sphere.position[2]
    config.resources.background.rotation.x = bundleConfig.sphere.rotation[0]
    config.resources.background.rotation.y = bundleConfig.sphere.rotation[1]
    config.resources.background.rotation.z = bundleConfig.sphere.rotation[2]
    config.resources.background.scale.x = bundleConfig.sphere.scale[0]
    config.resources.background.scale.y = bundleConfig.sphere.scale[1]
    config.resources.background.scale.z = bundleConfig.sphere.scale[2]
}

const bundlePrepareEnvironment = (bundleConfig)=>{

    // if (OrbitDayAndNight.active) return;

    if (config.resources.bundle.minitiles && (isMobile || isTablet)) {

        if (!OrbitDayAndNight.isActive) {
            const color = '#'+bundleConfig.tile.color.color
            const gamma = parseFloat(bundleConfig.tile.color.gamma)
            setColorGamma(color,gamma)
        }

    } else {


        if (bundleConfig.tile.url.length === 0) return;

        if (threeJsVariables.environment){
            setCoordinates(threeJsVariables.environment,bundleConfig.tile)
        }
        if (threeJsVariables.tilesRenderer){
            //threeJsVariables.tilesRenderer.errorTarget = bundleConfig.tile.errorTarget
        }
        const color = '#'+bundleConfig.tile.color.color
        const gamma = parseFloat(bundleConfig.tile.color.gamma)
        setColorGamma(color,gamma)
        //
        let list = config.resources.environments.environmentTypes
        //console.log(list)
        for (let i=0;i<list.length;i++){
            let a = list[i]

            //const tilesUrl = `${cdnRepository}/${projectFolder}/resources/tiles/${tilesSettings.path}`;

            a.settings.tilesSettings.path = 'tileset.json' //bundleConfig.tile.url
            a.settings.position.x = bundleConfig.tile.position[0]
            a.settings.position.y = bundleConfig.tile.position[1]
            a.settings.position.z = bundleConfig.tile.position[2]
            a.settings.rotation.x = bundleConfig.tile.rotation[0]
            a.settings.rotation.y = bundleConfig.tile.rotation[1]
            a.settings.rotation.z = bundleConfig.tile.rotation[2]
            a.settings.scale.x = bundleConfig.tile.scale[0]
            a.settings.scale.y = bundleConfig.tile.scale[1]
            a.settings.scale.z = bundleConfig.tile.scale[2]
        }

        let env = null
        if (isDesktop){
            env = list.filter(type => type.apply.filter(envType => envType.device === 'desktop')[0])[0]
        } else if (isMobile || isTablet){
            env = list.filter(type => type.apply.filter(envType => envType.device === 'mobile')[0])[0]
        } else {
            env = list.filter(type => type.apply.filter(envType => envType.device === 'web')[0])[0]
        }

        loadTilesEnvironment(env)

    }

}

const _base64ToBuffer = (base64)=> {
    const binary_string = window.atob(base64)
    const len = binary_string.length

    const bytes = new Uint8Array(len + Math.trunc(len/3))
    let j=0
    for (var i = 0; i < len; i=i+3) {
        bytes[j+0] = binary_string.charCodeAt(i+0)
        bytes[j+1] = binary_string.charCodeAt(i+1)
        bytes[j+2] = binary_string.charCodeAt(i+2)
        bytes[j+3] = 255
        j=j+4
    }
    return bytes
}

const bundlePrepareEffects = (gltf,bundleConfig)=>{
    const e = bundleConfig.effects
    setBokeh( e.dof.active, e.dof.aperture, e.dof.maxblur)

    if (e.lut.active){
        let data = _base64ToBuffer(e.lut.data)

        const t = new Data3DTexture()
		t.image.data = data
        t.format = RGBAFormat
		t.image.width = e.lut.height
		t.image.height = e.lut.height
		t.image.depth = e.lut.height
		t.type = UnsignedByteType
		t.magFilter = LinearFilter
		t.minFilter = LinearFilter
		t.wrapS = ClampToEdgeWrapping
		t.wrapT = ClampToEdgeWrapping
		t.wrapR = ClampToEdgeWrapping
		t.generateMipmaps = false
		t.needsUpdate = true

        setLut(e.lut.active,t,e.lut.intensity)
    }
}

const bundleInit = (bundleConfig,gltf,textureLoader,projectGroup)=>{

    bundlePrepareMaterials(bundleConfig,textureLoader)

    bundlePrepareAnimationList(bundleConfig,gltf)

    bundlePrepareBuildings(bundleConfig,gltf,projectGroup)

    bundlePrepareSceneObjects(bundleConfig,gltf,projectGroup)

    bundlePrepareFog(bundleConfig)

    bundlePrepareSphere(bundleConfig)

    bundlePrepareEnvironment(bundleConfig)

    bundleSetSun(bundleConfig)

    bundlePrepareEffects(gltf,bundleConfig)

    if (settingsData.isConferenceHost) {
        bundleConfig.textures ={
            "1.png": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "2.png": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "360_1.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 303,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "5.png": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "clear_puresky_low.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 303,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "default_lightMap.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 1,
                "colorSpace": "srgb-linear",
                "mapping": 303,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_10.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.07,
                    0.04
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_4.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.06,
                    0.03
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_4_emissive.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.06,
                    0.03
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_5.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.03,
                    0.03
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_5_emissive.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.03,
                    0.03
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_7.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.05,
                    0.07
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_7_emissive.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.05,
                    0.07
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_8_emissive.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.07,
                    0.04
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_9.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.04,
                    0.03
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "fasad_9_emissive.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "Roof_v5_2.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.01,
                    0.01
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "Roof_v8.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.01,
                    0.01
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "roof1new.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "srgb-linear",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    0.07,
                    0.07
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            },
            "water.jpg": {
                "center": [
                    0,
                    0
                ],
                "channel": 0,
                "colorSpace": "",
                "mapping": 300,
                "offset": [
                    0,
                    0
                ],
                "repeat": [
                    1,
                    1
                ],
                "rotation": 0,
                "wrapS": 1000,
                "wrapT": 1000
            }
        };
    }

    new Environment().load();
}

const mipmap = (size, color) => {
    const imageCanvas = document.createElement('canvas')
    const context = imageCanvas.getContext('2d')
    imageCanvas.width = size
    imageCanvas.height = size
    context.fillStyle = '#888888'
    context.fillRect(0, 0, size, size)
    context.fillStyle = color
    context.fillRect(0, 0, size / 2, size / 2)
    context.fillRect(size / 2, size / 2, size / 2, size / 2)
    return imageCanvas
}

const old_bundleInit = (gltf,textureLoader,projectGroup)=>{
    // загружаем текстуры для зданий
    let buildingsMaterial;
    const materialConfig = config.resources.bundle.material;
    if (materialConfig.specularMap) {
        buildingsMaterial = new MeshPhongMaterial();
    } else {
        buildingsMaterial = new MeshStandardMaterial();
        // buildingsMaterial.onBeforeCompile = (shader,renderer)=>{
        //     shader.fragmentShader = StandardFragment
        //     //shader.vertexShader = StandardVertex
        // }
    }
    const url = `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/building/`;
    for (let key in materialConfig) {
        const value = materialConfig[key];
        if ( value instanceof Object){
            const t = textureLoader.load(Cloudflare.resize(url + value.path),loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
            t.name = key;
            switch (key) {
                case 'envMap':
                    t.mapping = EquirectangularReflectionMapping
                    break;
                case 'lightMap':
                case 'aoMap':
                    t.channel = 1;
                    break

            }

            Object.entries(value).forEach(([key,value]) => {
                if (key !== 'path') {
                    t[key]  = value;
                    t.colorSpace = LinearSRGBColorSpace;
                    t.wrapS = RepeatWrapping;
                    t.wrapT = RepeatWrapping;
                    t.offset.set(0,0);
                    t.repeat.set(1,1);
                }
            });

            globalTextures[url + value.path] = t;

            buildingsMaterial[key] = t
        } else {
            buildingsMaterial[key] = value
        }
    }

    buildingsMaterial.lightMapIntensity *= Math.PI;

    // if (buildingsMaterial.specularMap===undefined){
    //     buildingsMaterial.lightMapIntensity = buildingsMaterial.lightMapIntensity*0.3
    // }


     // Add multiple materials
     if (config.resources.bundle.materials?.length) {
        const materialsArray = config.resources.bundle.materials;
        const url = `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/building/`;

        materialsArray.forEach(material => {

            multiTextures[material.building] = {};
            const textures = material.textures;

            // Load textures;
            Object.entries(textures).forEach(([key,value]) =>{
                const fullPath = Cloudflare.resize(url + value.path);
                let texture;

                if (globalTextures.hasOwnProperty(fullPath)) {
                    texture = globalTextures[fullPath];
                } else {
                    texture = textureLoader.load(Cloudflare.resize(url + value.path), loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
                    texture.name = key;
                    texture.colorSpace = LinearSRGBColorSpace;
                    texture.wrapS = RepeatWrapping;
                    texture.wrapT = RepeatWrapping;
                    texture.offset.set(0,0);
                    texture.repeat.set(1,1);

                    switch (key) {
                        case 'envMap':
                            texture.mapping = EquirectangularReflectionMapping;
                            break;
                        case 'lightMap':
                        case 'aoMap':
                            texture.channel = 1;
                            break
                    }

                    globalTextures[url + value.path] = texture;
                }

                multiTextures[material.building][key] = texture;
            });
        });
    }

    const {name,count} = config.resources.bundle.building;
    const {projectRotation} = config.threejs;
    projectGroup.rotation.set(projectRotation.x,projectRotation.y,projectRotation.z);

    for (let i = 0; i < count; i++){
        const building_name = name + String(i+1).padStart(2, '0');
        const building = gltf.scene.getObjectByName(building_name);

        if (!building) continue;

        let group = bundle_initAutoBuildingsScript(projectGroup,building,[]);

        const material = buildingsMaterial.clone();
        // if (material.specularMap===undefined){
        //     material.onBeforeCompile = (shader,renderer)=>{
        //         shader.fragmentShader = StandardFragment
        //         //shader.vertexShader = StandardVertex
        //     }
        // }

        if (Object.keys(multiTextures).length && multiTextures.hasOwnProperty(building_name)){
            const additionalTextures = multiTextures[building_name];

            Object.entries(additionalTextures).forEach(([key,value]) =>{
                material[key] = value;
            });
        }

        fixModelUV(group,material);

        group.traverse(o=>{
            if (o.isMesh) {
                if (o.material.map) {
                    o.material = material
                }
            }
        })
    }

}

const loadBundle = (manager) => {
    renderUpdateValuesOnDemand(true);
    const loader = new Loader();
    const textureLoader = loader.textureLoader;
    const dracoLoader = loader.dracoLoader;
    loader.addCallback = async () => {
        console.log('%c Bundle assets loaded', 'color: #00FF00');
        ProjectLogs.timerStopFor('bundle');
        ProjectLogs.timerStartFor('api_settings');
        ProjectLogs.timerStartFor('api_props');
        const settings = getSettings();
        const props = getProps();

        settings.then(response => {
            console.log('get settings');
            setProjectSettings(response);
            const dreamsSlider = getDreamsSliderScope();
            if (dreamsSlider) {
                const waitingFirstPreloaderAnimation = setInterval(() => {
                    if (!settingsData.preloaderRemoved) return;
                    if (!Environment.scope?.active || BmbyMode.active || !config.features.dayNight.checked || Environment.scope?.bundleLoaded) {
                        clearInterval(waitingFirstPreloaderAnimation);
                        console.log('update scene and add skip button');
                        threeJsVariables.composer.render();
                        dreamsSlider.callbacks.createSkipBtn();
                        ProjectLogs.timerStopFor('total');
                    }
                },100);
            } else {
                threeJsVariables.slicer.setInitialIntroHeight();
                projectMode.LiteMode.resizeContainer();
                intro();
                removePreloader();
            }
        });

        getAmenities().then((response) => {
            settingsData.amenities = response.data;
        });

        getSpecifications().then((response) => {
            settingsData.specifications = response.data;
        });

        Promise.all([props,settings]).then(response => {
            if (projectMode.AirMode.isSchematicBuildings()) {
                settingsData.allCrmData = response[0].data;
                projectMode.AirMode.createBuildings();
            } else if (!projectMode.LiteMode.isActive() ||
              (projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('regular') || projectMode.LiteMode.modeIs('rotate')))) {
                bundle_initAutoHighlightsScript(getHighlights().concat([response]));
            } else {
                settingsData.allCrmData = response[0].data;
                projectMode.LiteMode.loadBuildingModel();
            }
            
            

            // console.log(`Pagination.modalProp: ${Pagination.modalProp}`);
            // if (Pagination.modalProp)
            //     createModal(Pagination.modalProp);
            if (getUrlParam('p') !== 'map' && isNumeric(getUrlParam('p')) && !projectMode.LiteMode.isActive())
                projectMode.Pagination.paginate({source: 'widgetsInit'});

            if (BmbyMode.active) {
                const buildingsOrder = config.threejs.renderList?.list.find(el => el.name === 'Project Buildings');
                const selectionsOrder = config.threejs.renderList?.list.find(el => el.name === 'Project Selection' +
                  ' Boxes');
                if (buildingsOrder && !selectionsOrder) {
                    const selectionBoxOrder = {
                        name: 'Project Selection Boxes',
                        order: buildingsOrder.order + 1
                    };
                    config.threejs.renderList.list.push(selectionBoxOrder);
                }
                getVars(response[1].data);
                setInitialHtmlDirection(response[1].data);
                rightNavigationBar();
                const buildingId = getUrlParam('bid');
                if (buildingId) {
                    const building = config.buildings.find(building => building.buildingId === buildingId);
                    if (building) {
                        projectMode.Cylinder.enter(Buildings.getBuilding(building.buildingEngineId));
                    } else {
                        enterToTheBuildingWithMaxAvailableApartments();
                    }
                } else {
                    enterToTheBuildingWithMaxAvailableApartments();
                }
                threeJsVariables.renderList.reorder();
            }
    
            projectMode.QA = new QA().init();
            sendLogs(ProjectLogs.getLogs);

            // if (isMobile)
            //     components.mobileSearch = new MobileSearch();
        }).catch(error => {
            captureError(error);
            settingsData.loadingError = true;
        });

        startProjectWithError();
    };


    projectMode.LiteMode = new LiteMode();
    
    
    const needsRotor = simplifyBundleIsDisabled();

    if (isMobile && isIOS && needsRotor) {
        const fileLoader = loader.fileLoader;
        fileLoader.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/litemod/rotor/rotor.json?v=${Cloudflare.version}`,(cfg) => {
            config.resources.environments.active = false;
            config.features.environment.active = false;
            config.features.dayNight.active = false;
            projectMode.LiteMode.active = true;
            projectMode.LiteMode.mode = 'rotate';
            threeJsVariables.composer.composer.insertPass(projectMode.LiteMode,1);
            projectMode.LiteMode.init(loader);
            projectMode.LiteMode.rotor.init(cfg);
        },undefined,() => {
            projectMode.LiteMode.init(loader);
            if (projectMode.LiteMode.isActive()) {
                threeJsVariables.composer.composer.insertPass(projectMode.LiteMode,1);
            }
        });

    } else {
        projectMode.LiteMode.init(loader);
        if (projectMode.LiteMode.isActive()) {
            threeJsVariables.composer.composer.insertPass(projectMode.LiteMode,1);
        }
    }

    prepareSphere(textureLoader);

    if (projectMode.LiteMode.isActive() && !projectMode.LiteMode.modeIs('regular') && !projectMode.LiteMode.modeIs('rotate')) {
        const envToggle = new EnvironmentToggle();
        envToggle.load(manager);
        return;
    }

    // загружаем текстуры для зданий
    // '/assets/bundle.glb'
    // config.cdnRepository+'/'+config.projectFolder+'/resources/building/bundle.glb'
    // dracoLoader.load(config.cdnRepository+'/'+config.projectFolder+'/resources/building/bundle.glb',(gltf)=>{
    dracoLoader.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/building/bundle.glb?v=${Cloudflare.version}`,(gltf)=>{
        const projectGroup = new Group()
        projectGroup.name = 'Project Buildings'
        if (!projectMode.AirMode.isSchematicBuildings()) {
            threeJsVariables.scene.add(projectGroup)
        }
        threeJsVariables.renderList.reorder();

        const bundleConfig = gltf.scene.userData.config
         if (bundleConfig && !bundleConfig.version){
            threeJsVariables.bundleConfig = bundleConfig
            bundleInit(bundleConfig,gltf,textureLoader,projectGroup)
        } else if (bundleConfig && bundleConfig.version) {
             projectMode.AirMode.prepareBundleForAirMode(bundleConfig);
             threeJsVariables.bundleConfig = bundleConfig;
             newBundleInit(bundleConfig,gltf,textureLoader,projectGroup);
         } else{
            old_bundleInit(gltf,textureLoader,projectGroup)
            addSceneObjects(loader,textureLoader,dracoLoader,projectGroup)
        }

        const envToggle = new EnvironmentToggle();
        // envToggle.load(loader);
        !BmbyMode.active && envToggle.load();

        //tiles
        if (config.resources.environments.minitiles.active && (isMobile||isTablet) && !BmbyMode.active){
            const tiles = new Group();
            tiles.name = 'async env';
            let tileConfig = config.resources.environments.minitiles.tilesConfig;
            setCoordinates(tiles,tileConfig)
            threeJsVariables.scene.add(tiles);
            threeJsVariables.renderList.reorder();
            threeJsVariables.environment = tiles;

            let loaded = config.resources.environments.minitiles.tilesCount

            // const textureLoader2 = new TextureLoader()
            const dayNightActive = OrbitDayAndNight.active;

            for (let i=0;i<config.resources.environments.minitiles.tilesCount;i++){
                dracoLoader.load(config.cdnRepository+'/'+config.projectFolder+config.resources.environments.minitiles.tiles+'/tiles'+i+'.glb',(gltf)=>{
                    let g = gltf.scene.children[0]
                    g.name = i
                    let _m = g.material
                    _m.map.colorSpace = LinearSRGBColorSpace;

                    if (dayNightActive) {
                        g.material = new MeshStandardMaterial({
                            map: _m.map
                        });

                        g.castShadow = true;
                        g.receiveShadow = true;

                        g.geometry.computeVertexNormals();

                    } else {
                        g.material = basic_tile.clone();
                        g.material.uniforms.map.value = _m.map;
                        g.material.uniforms.hmap.value = basic_tile.uniforms.hmap.value;
                        _m.map.updateMatrix();
                        g.castShadow = false;
                        g.receiveShadow = false;
                        g.material.uniforms.uvTransform.value = _m.map.matrix;
                    }

                    tiles.add(g)

                })
            }


            if (OrbitDayAndNight.isActive) {

                const waitingEnvAndTiles = setInterval(() => {
                    const envMap =  Buildings.getBuildingsArray()[0].instances[0].material.envMap;
                    const tilesExist = tiles.children.length === config.resources.bundle.tilesCount;

                    if (envMap && tilesExist) {
                        clearInterval(waitingEnvAndTiles);

                        tiles.traverse(el => {
                            if (el.isMesh) {
                                el.material.envMap = envMap;
                            }
                        });
                    }
                }, 100);
            }

        }else{
            !bundleConfig && environmentToggle()
        }

        if (!config.threejs.renderer?.logarithmicDepthBuffer && !config.features?.hmap && !BmbyMode.active) {
            textureLoader.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/environment/hmap.png?v=${Cloudflare.version}`,(t)=>{
                setHMap(t)
            },(err)=>{
                //console.log(err)
            },(p)=>{
                //console.log(p)
            })
        }

        const sBoxes = [];
        const buildingsCount = config.resources.bundle.building.count;
        const buildingsName = config.resources.bundle.building.name;
        for (let i = 1; i <= buildingsCount; i++) {
            const name = `${buildingsName}${i.toString().padStart(2,'0')}_selectionBoxes`;
            const selections = gltf.scene.getObjectByName(name);
            if (selections) {
                sBoxes.push(selections);
            }
        }

        setHighlights(sBoxes);

        Buildings.getBuildingsArray().forEach(building => building.applyColorCorrection());

    },undefined,(err)=>{
        captureError(err);
        settingsData.loadingError = true;
    });
}

export async function initProjectMainScript() {
    const dictionary = await getDictionary();
    setProjectSettings(undefined, dictionary);

    ProjectLogs.timerStartFor('bundle');
    
    activateLiteModeForSimplifyBundle();
    
    if (!config.resources.bundle){
        const loader = new Loader();
        const textureLoader = loader.textureLoader;
        const dracoLoader = new DRACOLoader(loader);
        dracoLoader.setDecoderPath('../../../js/libs/gltf/');

        const textures = loadModelTexturesFromAzure(textureLoader);
        const models = loadBuildingModelsFromAzure(loader,dracoLoader);
        const crmData = getCrmData();

        crmData
            .then(response => {
                const selectionBoxes = loadHighlightsModelFromAzure(response,dracoLoader);
                return selectionBoxes;
            })
            .then(sBoxes => {
                const allForHighlights = lazyLoadingAll(sBoxes.concat(crmData));
                allForHighlights.then(response => {
                    initAutoHighlightsScript(response);
                });

                const opacityObjects = lazyLoadingAll([allForBuildings, allForHighlights]);
                opacityObjects.then(() => {
                    // addObjectsToOpacity();
                    intro();
                });
            });

        const allForBuildings = lazyLoadingAll(textures.concat(models));
        allForBuildings
            .then(response => initAutoBuildingsScript(response))
            .then( () => ProjectLogs.timerStopFor('bundle') );
        prepareSphere(projectMode.LiteMode.isActive(),textureLoader);
        environmentToggle();
        addSceneObjects(loader);
    } else {
        loadBundle();
    }

    projectMode.Cylinder = new Cylinder();
    projectMode.FloorPlan = new FloorPlan();
}


async function startProjectWithError () {
    // Check error
    if (!settingsData.loadingError) return;

    console.log('%c Project has been started with error', 'color: #ff0000');

    environmentToggle();
    intro();
    removePreloader();

    ProjectLogs.timerStopFor('total');
}

/*
New bundle support
* */

function newBundleInit (bundleConfig,gltf,textureLoader,projectGroup) {
    bundleOptimization(bundleConfig);

    if (bundleConfig.priority && Object.keys(bundleConfig.priority).length) {
        const splitedBundle = splitBundle(bundleConfig);

        prepareMiniMap(bundleConfig);
        prepareCameraAndOrbitControls(bundleConfig);
        prepareRenderer(bundleConfig);
        prepareCompass(bundleConfig);
        prepareSlicer(bundleConfig);
        projectMode.AirMode.saveState();
        prepareRenderList(bundleConfig);
        prepareLUTMesh(bundleConfig);
        setSceneEnvironment(bundleConfig,textureLoader);
        prepareAdditionalObjects(bundleConfig,textureLoader);
        //First bundle
        if (!projectMode.AirMode.isSchematicBuildings()) {
            prepareBuildings(splitedBundle.first,gltf.scene,textureLoader,projectGroup);
        }
    
        simplifyBundle(splitedBundle.first);
        simplifyBundle(splitedBundle.second);
        
        prepareSceneObjects(splitedBundle.first,gltf.scene,textureLoader);
        prepareInstances(splitedBundle.first,gltf.scene,textureLoader);
        prepareDecals(splitedBundle.first,textureLoader,gltf.scene);

        bundlePrepareSphere(bundleConfig);
        prepareTiles(bundleConfig,textureLoader);
        prepareLight(bundleConfig);
        projectMode.AirMode.init(textureLoader);
        projectMode.AirMode.start();

        if (!isMobile && !projectMode.AirMode.active) {
            if (threeJsVariables.quality.optimizationTasks()) {
                threeJsVariables.composer.disableAll();
                const effectsTask = new OptimizationTask((fps) => {
                    if (fps > 20 && effectsTask.currentCount >= effectsTask.maxCount - 1) {
                        prepareEffects(bundleConfig);
                        effectsTask.finished = true;
                    }
                },1,10);
            } else {
                prepareEffects(bundleConfig);
            }
        }

        const mainLoadingManager = Loader.scopes[0];
        mainLoadingManager.addCallback = () => {
            threeJsVariables.orbitBuildingsNavigation.objectsVisibility(false);
            const loader = new Loader();
            if (simplifyBundleIsDisabled()) {
                new Environment().load();
            }
            loader.addCallback = () => {
                threeJsVariables.orbitBuildingsNavigation.objectsVisibility(false);
                updateShadowMap();
                projectMode.AirMode.toggleSceneObjects(false);
                console.log('stage 2');
                // new Environment().load();
            };

            const tl = loader.lazyTextureLoader;
            const draco = loader.dracoLoader;

            if (isMobile) {
                if (!projectMode.LiteMode.modeIs('rotate')) {
                    const secondBundleTask = new OptimizationTask((fps) => {
                        if (fps > settingsData.fps) {
                            loadSecondBundle();
                            secondBundleTask.finished = true;
                        }
                    },1,5);
                }

                let pixelRatio = threeJsVariables.composer.getPixelRatio();
                const pixelRatioTask = new OptimizationTask((fps) => {
                    if (fps < settingsData.fps) {
                        let clamped = clamp(pixelRatio * 0.85,1,2);
                        pixelRatio = clamped;
                        threeJsVariables.composer.setPixelRatio(clamped);
                    }else {
                        pixelRatioTask.finished = true;
                    }
                },10,5);

            } else {
                loadSecondBundle();
            }

            function loadSecondBundle () {
                if (BmbyMode.active)
                    return;
                // draco.load(config.cdnRepository+'/'+config.projectFolder+'/resources/building/bundle_second.glb',gltf_second => {
                draco.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/building/bundle_second.glb?v=${Cloudflare.version}`,gltf_second => {
                    console.log('%csecond bundle loaded', 'color: palegreen');
                    if (!projectMode.AirMode.isSchematicBuildings()) {
                        prepareBuildings(splitedBundle.second,gltf_second.scene,tl,projectGroup);
                    }
                    prepareSceneObjects(splitedBundle.second,gltf_second.scene,tl);
                    prepareInstances(splitedBundle.second,gltf_second.scene,tl);
                    prepareDecals(splitedBundle.second,tl,gltf_second.scene);
                    prepareObjectsToDisappear();
                    if (isMobile) {
                        if (threeJsVariables.sceneObjectsSlicer.active) {
                            Buildings.getBuildingsArray().forEach(building => building.updateAttachedModelsList());
                        } else if (settingsData.activeViewMode !== ViewMode.Orbit) {
                            hideSceneObjects(Buildings.getActiveBuilding());
                        }

                        const displayOptions = document.querySelector('.display-options__options');
                        if (displayOptions)
                            new FutureDevelopment(displayOptions).createSwitcher();
                    }
                    removeObjectsFromScene();
                },undefined,error => captureError(error));
            }
        }
    } else {
        //Lazy loading
        const mainLoadingManager = Loader.scopes[0];
        mainLoadingManager.addCallback = () => {
            const loader = new Loader();
            loader.addCallback = () => {
                updateShadowMap();
                console.log('stage 2');
            };
            const tl = loader.lazyTextureLoader;
            prepareSceneObjects(bundleConfig,gltf.scene,tl);
            prepareInstances(bundleConfig,gltf.scene,tl);
            prepareDecals(bundleConfig,tl,gltf.scene);
            new Environment().load();
        };
        prepareLUTMesh(bundleConfig);
        prepareEffects(bundleConfig);
        setSceneEnvironment(bundleConfig,textureLoader);
        prepareBuildings(bundleConfig,gltf.scene,textureLoader,projectGroup);
        bundlePrepareSphere(bundleConfig);
        prepareTiles(bundleConfig,textureLoader);
        prepareLight(bundleConfig);
    }

    // Without lazy loading

    // setSceneEnvironment(bundleConfig,textureLoader);
    // prepareLUTMesh(bundleConfig);
    // prepareEffects(bundleConfig);
    // prepareBuildings(bundleConfig,gltf.scene,textureLoader,projectGroup);
    // prepareSceneObjects(bundleConfig,gltf.scene,textureLoader);
    // prepareInstances(bundleConfig,gltf.scene,textureLoader);
    // prepareDecals(bundleConfig,textureLoader,gltf.scene);
    // bundlePrepareSphere(bundleConfig);
    // prepareTiles(bundleConfig,textureLoader);
    // prepareLight(bundleConfig.lights);
}

function splitBundle (config) {
    const first = {
        animations: config.animations,
        materialTypes: config.materialTypes,
        buildings: {},
        sceneObjects: {},
        instances: {},
        decals: {},
        shadowSettings: {}
    };

    const second = {
        animations: config.animations,
        materialTypes: config.materialTypes,
        buildings: {},
        sceneObjects: {},
        instances: {},
        decals: {},
        shadowSettings: {}
    };

    const priorities = config.priority;
    if (!priorities) {
        return config;
    }

    //Buildings
    Object.entries(config.buildings).forEach(([name,data]) => {
       const priority = priorities[name];
       if (priority === 1) {
           first.buildings[name] = data;
       } else {
           second.buildings[name] = data;
       }
    });

    //Scene objects
    Object.entries(config.sceneObjects).forEach(([parentName,elements]) => {
        const priority = priorities[parentName];
        if (priority === 1) {
            first.sceneObjects[parentName] = elements;
        } else {
            second.sceneObjects[parentName] = elements;
        }
    });

    //Instances
    Object.entries(config.instances).forEach(([modelName,modelSettings]) => {
        const priority = priorities[modelName];
        if (priority === 1) {
            first.instances[modelName] = modelSettings;
        } else {
            second.instances[modelName] = modelSettings;
        }
    });

    //Decals
    Object.entries(config.decals).forEach(([name,data]) => {
        const priority = priorities[name];
        if (priority === 1) {
            first.decals[name] = data;
        } else {
            second.decals[name] = data;
        }
    });


    config.shadowSettings && Object.entries(config.shadowSettings).forEach(([name,data]) => {
        first.shadowSettings[name] = data;
        second.shadowSettings[name] = data;
    });

    return {
        first,
        second
    };
}

function bundleOptimization (bundleConfig) {
    if (isMobile) {
        // Disable effects
        Object.values(bundleConfig.effects).forEach(effect => effect.enabled = false);

        //Decrease shadow map size
        const mapSize = bundleConfig.lights.directionalLight.shadow.mapSize.x;
        const cameraSize = bundleConfig.lights.directionalLight.shadow.camera.size;
        bundleConfig.lights.directionalLight.shadow.mapSize.x = Math.min(mapSize,1024);
        bundleConfig.lights.directionalLight.shadow.mapSize.y = Math.min(mapSize,1024);
        bundleConfig.lights.directionalLight.shadow.camera.size = Math.min(cameraSize,150);
    }
}

function prepareDecals (bundleConfig,textureLoader,scene) {
    if (bundleConfig.decals && Object.keys(bundleConfig.decals).length) {
        Object.entries(bundleConfig.decals).forEach(([name,data]) => {
           const object = scene.getObjectByName(name);
           if (object) {
               let shadowSettings = getShadowParams(bundleConfig,name);
               if (!shadowSettings) {
                   shadowSettings = {
                       castShadow: false,
                       receiveShadow: true
                   }
               }
               const materialType = getMaterialType(bundleConfig,name);
               const material = prepareMaterial(data.material,textureLoader,materialType,true);
               fixModelUV(object,material);
               fixEnvMapMaterial(material);
               material.transparent = true;
               material.depthWrite = false;
               material.transparent = true;
               material.polygonOffset = true;
               material.polygonOffsetFactor = -4;
               object.material = material;
               // threeJsVariables.slicer.add(object);
               threeJsVariables.sceneObjectsSlicer.add(object);
               object.receiveShadow = shadowSettings.receiveShadow;
               object.castShadow = shadowSettings.castShadow;
               sceneObjectsGroup.add(object);
               // lazyHideSceneObject(object);
           }
        });
    }

    if (sceneObjectsGroup.children.length && sceneObjectsGroup.parent === null){
        threeJsVariables.scene.add(sceneObjectsGroup);
        threeJsVariables.renderList.reorder();
        updateShadowMap();
    }
}

function setSceneEnvironment (bundleConfig,textureLoader) {
    if (bundleConfig.scene) {
        const fileName = bundleConfig.scene.environment;
        if (fileName) {
            let texture = bundleTextures[fileName];
            if (!texture) {
                texture = loadTexture(fileName,textureLoader);
                bundleTextures[fileName] = texture;
            }
            const cloneTexture = texture.clone();
            cloneTexture.mapping = EquirectangularReflectionMapping;
            threeJsVariables.scene.environment = cloneTexture;

            if (bundleVersionEquals(2.0)) {
                const environmentPlug = plugTexture();
                environmentPlug.name = 'default-envMap.png';
                environmentPlug.mapping = EquirectangularReflectionMapping;
                environmentPlug.minFilter = NearestFilter;
                environmentPlug.magFilter = NearestFilter;
                environmentPlug.anisotropy = 0;
                environmentPlug.needsUpdate = true;
                threeJsVariables.scene.userData.environmentPlug = environmentPlug;
            }

            if (bundleConfig.scene.environmentRotation) {
                threeJsVariables.scene.environmentRotation.fromArray(bundleConfig.scene.environmentRotation);
            }

            if (bundleConfig.scene.hasOwnProperty('environmentIntensity')) {
                threeJsVariables.scene.environmentIntensity = bundleConfig.scene.environmentIntensity;
            }
        }
    }
}

function prepareEffects (bundleConfig) {
   if (bundleConfig.effects) {
        Object.entries(bundleConfig.effects).forEach(([name,settings]) => {
           const effect = threeJsVariables.composer.getPass(name);
           if (effect) {
               effect.config = settings;
           }
        });
   }
}

function prepareLUTMesh (bundleConfig) {
    const lut = bundleConfig.lut;
    if (!lut || !Object.keys(lut).length) return;

    const lutLoader = new Loader().luteLoader;
    const parsedLut = {};
    //Source
    Object.entries(lut.source).forEach(([name,data]) => {
        parsedLut[name] = lutLoader.parse(data);
        parsedLut[name].texture3D.colorSpace = LinearSRGBColorSpace;
        parsedLut[name].texture3D.needsUpdate = true;
    });

    Object.entries(lut).forEach(([key,value]) => {
        if (key !== 'source') {
            if (value.lutsPresets) {
                const lut = new LUT(key);
                Object.keys(value.lutsPresets).forEach(dayTime => {
                    value.lutsPresets[dayTime].lut = parsedLut[value.lutsPresets[dayTime].name];
                });
                lut.lutConfig = value;
            } else {
                value.lut = parsedLut[value.name];
                const lut = new LUT(key);
                lut.lutConfig = value;
            }
        }
    });
}

function prepareTiles (bundleConfig,textureLoader) {
    if (config.resources.environments.active && !projectMode.AirMode.active) {
        if (bundleConfig.tiles.hmap) {
            textureLoader.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/environment/hmap.png?v=${Cloudflare.version}`,texture => {
                texture.minFilter = NearestFilter;
                texture.magFilter = NearestFilter;
                texture.generateMipmaps = false;
                texture.flipY = false;
                Hmap.texture = texture;
            });
        }

        if (bundleConfig.tiles.overlay) {
            textureLoader.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/environment/tiles-overlay.png?v=${Cloudflare.version}`,texture => {
                texture.minFilter = NearestFilter;
                texture.magFilter = NearestFilter;
                texture.generateMipmaps = false;
                texture.flipY = false;
                Hmap.overlay = texture;
            });
        }

        if (bundleConfig.tiles.material) {
            const materialConfig = bundleConfig.tiles.material.config;
            const materialType = getMaterialType(bundleConfig,'tiles');
            if (Object.keys(materialConfig).length) {
                const material = prepareMaterial(materialConfig,textureLoader,materialType);
                setDefaultTileMaterial(material);
            }
        }

        let shadowSettings = getShadowParams(bundleConfig,'tiles');
        if (!shadowSettings) {
            shadowSettings = {
                castShadow: true,
                receiveShadow: true
            }
        }
        setTilesShadowParams(shadowSettings);
        environmentToggle();
    }
}


function prepareBuildings (config,scene,textureLoader,projectGroup) {
    const lut = LUT.getScope('buildings');

    Object.entries(config.buildings).forEach(([name,material]) => {
        const n = name.replaceAll(/_/g,'');
        const building = scene.getObjectByName(n);
        if (building) {
            const materialType = getMaterialType(config,name);
            const isInterior = findMaterialType('InteriorMaterial',materialType);
            const compiledMaterial = prepareMaterial(material,textureLoader,materialType);
            fixModelUV(building,compiledMaterial);
            fixEnvMapMaterial(compiledMaterial);
            let shadowSettings = getShadowParams(config,n);
            if (!shadowSettings) {
                shadowSettings = {
                    castShadow: true,
                    receiveShadow: true
                }
            }
            lut && lut.include(compiledMaterial);
            let compiledBuilding = bundle_initAutoBuildingsScript(projectGroup,building);
            compiledBuilding.traverse(el => {
                if (el.isMesh) {
                    isInterior && InteriorMaterial.prepareMesh(el);
                    el.material = compiledMaterial;
                    threeJsVariables.slicer.add(el);
                    el.castShadow = shadowSettings.castShadow;
                    el.receiveShadow = shadowSettings.receiveShadow;
                    addToPoiIntersections(el);
                }
            });
        }
    });
}

export function getMaterialType (config,name) {
    if (!config.materialTypes) return 'MeshStandardMaterial';
    const type = config.materialTypes[name];
    if (type) {
        return type;
    } else {
        return 'MeshStandardMaterial';
    }
}

export function getShadowParams (config,name) {
    if (config.shadowSettings && Object.keys(config.shadowSettings).length) {
        return config.shadowSettings[name];
    }
    return null;
}

function prepareInstances (config,scene,textureLoader) {
    if (!Object.keys(config.instances).length) return;

    const matrix = new Matrix4();
    const lut = LUT.getScope('sceneObjects');
    Object.entries(config.instances).forEach(([modelName,modelSettings]) => {
        const object = scene.getObjectByName(modelName);
        if (object) {
            const materialType = getMaterialType(config,modelName);
            const material = prepareMaterial(modelSettings.material,textureLoader,materialType,true);
            fixModelUV(object,material);
            fixEnvMapMaterial(material);
            let shadowSettings = getShadowParams(config,object.name);
            if (!shadowSettings) {
                shadowSettings = {
                    castShadow: true,
                    receiveShadow: true
                }
            }

            const count = modelSettings.points.length;

            if (modelSettings.isLOD) {
                const instanceLOD = new InstanceLOD();
                instanceLOD.name = modelName;
    
                modelSettings.distances = modelSettings.distances.map(dist => dist * threeJsVariables.quality.lodDistanceCoefficient());

                object.children.forEach((lod,index) => {
                    lut && lut.include(material[index]);
                    if (lod.userData.groups) {
                        lod.geometry.groups = lod.userData.groups;
                    }
                    lod.material = material[index];
                    const isInterior = findMaterialType('InteriorMaterial',materialType[index]);
                    isInterior && InteriorMaterial.prepareMesh(lod);

                    const instance = new InstancedMesh(lod.geometry,lod.material,count);
                    instance.name = lod.name;

                    modelSettings.points.forEach((point,index) => {
                        matrix.fromArray(point.matrix);
                        instance.setMatrixAt(index, matrix);
                    });

                    // threeJsVariables.slicer.add(instance);
                    instance.receiveShadow = shadowSettings.receiveShadow;
                    instance.castShadow = shadowSettings.castShadow;
                    instance.computeBoundingSphere();
                    addToPoiIntersections(instance);
                    instanceLOD.addLevel(instance,modelSettings.distances[index]);
                    let animation;
                    modelSettings.points.forEach((point,index) => {
                        animation = config.animations[modelName + '::' + index];
                        if (animation) {
                            new AnimateObject(instanceLOD,animation);
                        }
                    });
                    threeJsVariables.sceneObjectsSlicer.add(instance);
                });
                
                instanceLOD.setLevel(threeJsVariables.quality.lodLevel());
                sceneObjectsGroup.add(instanceLOD);
                threeJsVariables.renderList.reorder();
                updateShadowMap();
                // lazyHideSceneObject(instanceLOD);
            } else {
                lut && lut.include(material);
                if (object.userData.groups) {
                    object.geometry.groups = object.userData.groups;
                }

                object.material = material;
                const isInterior = findMaterialType('InteriorMaterial',materialType);
                isInterior && InteriorMaterial.prepareMesh(object);
                const instance = new InstancedMesh(object.geometry,object.material,count);
                instance.name = object.name;
                instance.receiveShadow = shadowSettings.receiveShadow;
                instance.castShadow = shadowSettings.castShadow;
                
                let animation;
                modelSettings.points.forEach((point,index) => {
                    matrix.fromArray(point.matrix);
                    instance.setMatrixAt(index, matrix);
                    animation = config.animations[modelName + '::' + index];
                    if (animation) {
                        new AnimateObject(instance,animation);
                    }
                });

                // threeJsVariables.slicer.add(instance);
                instance.geometry.computeBoundsTree();
                instance.computeBoundingSphere();
                addToPoiIntersections(instance);
                sceneObjectsGroup.add(instance);
                threeJsVariables.sceneObjectsSlicer.add(instance);
                threeJsVariables.renderList.reorder();
                updateShadowMap();
                // lazyHideSceneObject(instance);
            }
        }
    });

    if (sceneObjectsGroup.children.length && sceneObjectsGroup.parent === null){
        threeJsVariables.scene.add(sceneObjectsGroup);
        threeJsVariables.renderList.reorder();
        updateShadowMap();
    }
}

function prepareSceneObjects (bundleConfig,scene,textureLoader) {
    const lut = LUT.getScope('sceneObjects');
    const models = config.resources.sceneObjects.models || [];
    const attachedNames = models.map(el => el.name);

    Object.entries(bundleConfig.sceneObjects).forEach(([parentName,elements]) => {
        const object = scene.getObjectByName(parentName);
        if (object) {
            object.traverse(el => {
               if (el.isMesh) {
                   if (el.userData.groups) {
                       el.geometry.groups.push(...el.userData.groups);
                   }
                   const settings = elements[el.name];
                   if (settings) {
                       const materialType = getMaterialType(bundleConfig,el.name);
                       const isInterior = findMaterialType('InteriorMaterial',materialType);
                       isInterior && InteriorMaterial.prepareMesh(el);
                       const material = prepareMaterial(settings,textureLoader,materialType,false);
                       fixModelUV(el,material);
                       fixEnvMapMaterial(material);
                       lut && lut.include(material);
                       el.material = material;
                       // threeJsVariables.slicer.add(el);
                   }
                   let shadowSettings = getShadowParams(bundleConfig,el.name);
                   if (!shadowSettings) {
                       shadowSettings = {
                           castShadow: true,
                           receiveShadow: true
                       }
                   }

                   el.castShadow = shadowSettings.castShadow;
                   el.receiveShadow = shadowSettings.receiveShadow;
                   el.geometry.computeBoundsTree();
                   addToPoiIntersections(el);
                   if (!attachedNames.includes(el.name)) {
                       threeJsVariables.sceneObjectsSlicer.add(el);
                   }
               }
            });


            const animation = bundleConfig.animations[parentName];
            if (animation) {
                new AnimateObject(object,animation);
            }

            sceneObjectsGroup.add(object);
            updateShadowMap();
            // lazyHideSceneObject(object);
        }
    });

    if (sceneObjectsGroup.children.length){
        threeJsVariables.scene.add(sceneObjectsGroup);
        threeJsVariables.renderList.reorder();
        updateShadowMap();
    }

}

export function prepareMaterial (settings,textureLoader,materialType,manualTextureResize = false) {
    let material = [];
    if (Array.isArray(settings)) {
        settings.forEach((personalMaterialSettings,index) => {
            if (Array.isArray(personalMaterialSettings)) {
                const thirdMaterials = [];
                personalMaterialSettings.forEach((thirdMaterial,thirdIndex) => {
                    const subMaterialType = materialType[index][thirdIndex];
                    const singleMaterial = getMaterial(thirdMaterial,textureLoader,subMaterialType,manualTextureResize);
                    thirdMaterials.push(singleMaterial);
                });
                material.push(thirdMaterials);
            } else {
                const subMaterialType = materialType[index];
                const singleMaterial = getMaterial(personalMaterialSettings,textureLoader,subMaterialType,manualTextureResize);
                material.push(singleMaterial);
            }
        });
    } else {
        material = getMaterial(settings,textureLoader,materialType,manualTextureResize);
    }

    return material;
}

function getMaterial (settings,textureLoader,materialType,manualTextureResize) {
    let material;
    switch (materialType) {
        case 'MeshStandardMaterial':
            material = new MeshStandardMaterial();
            break;
        case 'MeshBasicMaterial':
            material = new MeshBasicMaterial();
            break;
        case 'DisplacementMaterial':
            material = new DisplacementMaterial();
            threeJsVariables.composer.addUpdatableElement(material);
            break;
        case 'InteriorMaterial':
            material = new InteriorMaterial();
            break;
        case 'FluffyMaterial':
            material = new FluffyMaterial();
            threeJsVariables.composer.addUpdatableElement(material);
            break;
        case 'LayerMaterial':
            material = new LayerMaterial();
            break;
        case 'SeaMaterial':
            material = new SeaMaterial(threeJsVariables.scene.getObjectByName('Dir. Light'));
            threeJsVariables.composer.addUpdatableElement(material);
            break;
        case 'TreeMaterial':
            material = new PointsMaterial();
            break;
        case 'AdditionalStandardMaterial':
            material = new AdditionalStandardMaterial();
            break;
        case 'MeshPhysicalMaterial':
            material = new MeshPhysicalMaterial();
            break;
        default:
            material = new MeshStandardMaterial();
            break;
    }

    material.userData.defaultSettings = JSON.parse(JSON.stringify(settings));
    const getterSetter = ['alphaTest','reflectivity','anisotropy','clearcoat','dispersion','iridescence','sheen','transmission'];
    Object.entries(settings).forEach(([key,value]) => {
        if (!material.hasOwnProperty(key) && !getterSetter.includes(key)) return;

        if (typeof value === 'string') {
            if (value.startsWith('#')) {
                material[key].setStyle(value,LinearSRGBColorSpace);
            } else if (value === 'Infinity') {
                material[key] = Infinity;
            } else {
                let texture = bundleTextures[value];

                if (!texture) {
                    if (isMobile) {
                        texture = loadTexture(value,textureLoader,manualTextureResize);
                    } else if (threeJsVariables.quality.optimizationTasks()) {
                        const textureSize = {width: 512};
                        texture = loadTexture(value,textureLoader,manualTextureResize,textureSize,false,(loadedTexture) => {
                            const width = loadedTexture.source.data.naturalWidth;
                            if (width === textureSize.width) {
                                const textureTask = new UpdateTask(async () => {
                                    const newTexture = await loadTexture(value,_tlLoader,manualTextureResize,null,true);
                                    material[key].dispose();
                                    material[key] = null;
                                    bundleTextures[value] = newTexture;
                                    setInitialTextureSettings(key,newTexture);
                                    prepareTexture(value,newTexture);
                                    material[key] = newTexture;
                                });

                                threeJsVariables.tasks.addTask(textureTask);
                            }
                        });
                    } else {
                        texture = loadTexture(value,textureLoader,false);
                    }
                    bundleTextures[value] = texture;
                }

                if (value.startsWith('nightLights')) {
                    const slotKey = key.startsWith('emissive') ? 'emissiveIntensity' : 'lightMapIntensity';

                    if (!OrbitDayAndNight.isActiveAndSelected) {
                        material[slotKey] = 0;
                    }

                    OrbitDayAndNight.buildingMaterials.push({
                        key: slotKey,
                        material
                    });
                }

                setInitialTextureSettings(key,texture);
                prepareTexture(value,texture);
                material[key] = texture;
            }
        } else if (Array.isArray(value) && !Array.isArray(material[key])) {
            material[key].fromArray(value);
        } else {
            if (key === 'lightMapIntensity' && bundleVersionEquals(1)) {
                material[key] = value * Math.PI;
            } else {
                material[key] = value;
            }
        }
    });

    if (material.emissiveMap || (material.lightMap && material.lightMapIntensity === 0 && config.features.dayNight.settings.useLightMapAsEmissiveMap)) {

        if (!OrbitDayAndNight.preloaded) {
            OrbitDayAndNight.preloaded = {
                materials: []
            }
        }

        OrbitDayAndNight.preloaded.materials.push(material);
    }

    return material;
}

function loadTexture (name,textureLoader,manualTextureResize,preloadParams,async,onLoad) {
    const url = `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/textures/building/`;
    const extension = getFileExtension(name);

    if (extension === 'hdr') {
        hdrLoader.manager = textureLoader.manager;
        return hdrLoader.load(url + name);
    } else {
        const resized =  preloadParams ? Cloudflare.resize(url + name,preloadParams) : manualTextureResize ? Cloudflare.resize(url + name,{
            width: 512
        }) : Cloudflare.resize(url + name);
        // return textureLoader.load(resized,loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
        if (async) {
            return textureLoader.loadAsync(resized);
        } else {
            if (onLoad) {
                return textureLoader.load(resized,onLoad);
            } else {
                return textureLoader.load(resized);
            }
        }
    }
}

function prepareTexture (name,texture) {
    const bundleConfig = threeJsVariables.bundleConfig;
    if (bundleConfig.textures) {
        const config = bundleConfig.textures[name];
        if (config) {
            Object.entries(config).forEach(([key,value]) => {
                if (Array.isArray(value)) {
                    texture[key].fromArray(value);
                } else {
                    texture[key] = value;
                }
            });
            texture.needsUpdate = true;
        }
    }
}

function prepareAdditionalObjects (bundleConfig,textureLoader) {
    if (bundleConfig.additionalObjects && bundleConfig.additionalObjects.length) {
        new Objects(bundleConfig.additionalObjects).add(textureLoader);
    }
}

function addToPoiIntersections (mesh) {
    const config = threeJsVariables.bundleConfig.intersections;
    if (config && config.includes(mesh.name)) {
        addBuildingsIntersections(mesh);
    }
}

function setInitialTextureSettings (key,texture) {
    switch (key) {
        case 'envMap':
            texture.mapping = EquirectangularReflectionMapping;
            texture.channel = 0;
            break;
        case 'aoMap':
        case 'lightMap':
            texture.channel = 1;
            break;
        default:
            texture.channel = 0;
            break;
    }

    texture.colorSpace = LinearSRGBColorSpace;
    texture.wrapS = RepeatWrapping;
    texture.wrapT = RepeatWrapping;
    texture.offset.set(0, 0);
    texture.repeat.set(1, 1);

    texture.anisotropy = 2;
    texture.magFilter = LinearFilter;
    texture.minFilter = LinearMipmapLinearFilter;
}

export function bundleVersionEquals (version) {
    return threeJsVariables.bundleConfig.version === version;
}

function findMaterialType (type,data) {
    let result;
    if (Array.isArray(data)) {
       const join = data.reduce((acc,value) => {
           if (Array.isArray(value)) {
               acc.push(...value);
           } else {
               acc.push(value);
           }
           return acc;
       },[]);

       result = join.includes(type);
    } else {
        result = type === data;
    }

    return result;
}

export function fixEnvMapMaterial (material) {
    function fix (mat) {
        if (mat.envMapIntensity === 0) {
            mat.envMap = threeJsVariables.scene.userData.environmentPlug;
        } else if (mat.envMap === null) {
            mat.envMap = threeJsVariables.scene.environment;
        }

        mat.needsUpdate = true;
    }

    if (threeJsVariables.scene.environment && bundleVersionEquals(2.0)) {
        if (Array.isArray(material)) {
            material.forEach(subMaterial => fix(subMaterial));
        } else {
            fix(material);
        }
    }
}

export function fixModelUV (object,material) {
    let needsCheck = false;

    if (Array.isArray(material)) {

        for (let i = 0; i < material.length; i++) {
            if (material[i].lightMap || material[i].aoMap) {
                needsCheck = true;
                break;
            }
        }

    } else {
        if (material.lightMap || material.aoMap) {
            needsCheck = true;
        }
    }

    object.traverse(el => {
       if (el.isMesh) {
           Object.entries(el.geometry.attributes).forEach(([key,value]) => {
              if (key.startsWith('_')) {
                  const attributeKey = key.replace('_','');
                  el.geometry.setAttribute(attributeKey,value);
                  el.geometry.deleteAttribute(key);
              }
           });

           if (needsCheck) {
               const attribute = el.geometry.getAttribute('uv1');
               if (!attribute) {
                   el.geometry.setAttribute('uv1',el.geometry.getAttribute('uv').clone())
               }
           }
       }
    });
}

function prepareRenderer (bundleConfig) {
    if (bundleConfig.renderer) {
        threeJsVariables.renderer.toneMapping = bundleConfig.renderer.toneMapping;
        threeJsVariables.renderer.toneMappingExposure = bundleConfig.renderer.toneMappingExposure;

        if (bundleConfig.renderer.hasOwnProperty('shadowMap')) {
            threeJsVariables.renderer.shadowMap.type = bundleConfig.renderer.shadowMap;
        }

        if (bundleConfig.renderer.hasOwnProperty('outputColorSpace')) {
            threeJsVariables.renderer.outputColorSpace = bundleConfig.renderer.outputColorSpace;
        }
    }
}

function prepareCompass (bundleConfig) {
    if (bundleConfig.compass) {
        config.threejs.compass.correction = bundleConfig.compass.correction;
    }
}

function prepareCameraAndOrbitControls (bundleConfig) {
    if (config.threejs.orbitControls.fromBundle) {
        const orbitControls = bundleConfig.orbitControls;
        const camera = bundleConfig.camera;
        if (orbitControls) {
            config.threejs.orbitControls.target = orbitControls.target;
            config.threejs.orbitControls.orbit = orbitControls.orbit;
            // config.threejs.orbitControls.cylinder = orbitControls.cylinder;
            // config.threejs.orbitControls.floorplan = orbitControls.floorplan;
            threeJsVariables.orbitControls.target.set(
                orbitControls.target.x,
                orbitControls.target.y,
                orbitControls.target.z,
            );
            setOrbitControls(ViewMode.Orbit);
            setPolarAngle(ViewMode.Orbit);
            setPanLimits(ViewMode.Orbit);
        }

        if (camera) {
            config.threejs.camera = camera;
            threeJsVariables.perspectiveCamera.position.set(
                camera.position.x,
                camera.position.y,
                camera.position.z
            );
        }

        setViewDeviceTargetAndPosition(ViewMode.Orbit);
    }

    if (bundleConfig.cameraProjection) {
        // threeJsVariables.perspectiveCamera.fov = bundleConfig.cameraProjection.fov;
        threeJsVariables.perspectiveCamera.near = bundleConfig.cameraProjection.near;
        threeJsVariables.perspectiveCamera.far = bundleConfig.cameraProjection.far;
        threeJsVariables.perspectiveCamera.updateProjectionMatrix();
    }
}

function prepareSlicer (bundleConfig) {
    if (bundleConfig.slicer && Object.keys(bundleConfig.slicer).length) {
        const presets = {};
        const defaultPlanes = 5;
        const maxPlanes = Math.max(...Object.values(bundleConfig.slicer).map(planes => planes.length));
        const planesCount = maxPlanes - defaultPlanes;

        if (planesCount > 0) {
            threeJsVariables.slicer.numberOfPlanes += planesCount;
            threeJsVariables.sceneObjectsSlicer.numberOfPlanes += planesCount;
            threeJsVariables.slicer.setDefaultPlanes();
            threeJsVariables.sceneObjectsSlicer.setDefaultPlanes();
        }

        Object.entries(bundleConfig.slicer).forEach(([name,planes]) => {
            presets[name] = [];
            planes.forEach(plane => {
               presets[name].push(new Plane(new Vector3().fromArray(plane.normal),plane.constant));
            });
        });

        threeJsVariables.slicer.setSlicerPresets(presets);
        threeJsVariables.sceneObjectsSlicer.setSlicerPresets(presets);
    }
}

function prepareRenderList (bundleConfig) {
    if (Array.isArray(bundleConfig.renderList) && bundleConfig.renderList.length && config.threejs.renderList?.active) {
        config.threejs.renderList.list.push(...bundleConfig.renderList);
    }
}

function prepareMiniMap (bundleConfig) {
    if (bundleConfig.miniMap) {
        threeJsVariables.googleMiniMap.config = bundleConfig.miniMap;
    }
}


function isDeviceSupportForSimplifyBundle (devices) {
    let device = 'none';
    
    if (isMobile) {
        if (isIOS) {
            device = 'iphone';
        } else {
            device = 'android';
        }
    } else if (isWeb) {
        device = 'web';
    } else if (isDesktop) {
        device = 'desktop';
    } else if (isTablet) {
        device = 'tablet';
    }
    
    return devices.includes(device);
}

/*
"simplifyBundle": {
    "active": true,
        "devices": ["android","iphone","web"],
        "sceneObjects": [],
        "liteMode": {
        "active": true,
    }
}*/


function simplifyBundle (bundleConfig) {
    const params = config.resources.bundle.simplifyBundle || {};
    if (!params.active)
        return;
    
    const supported = isDeviceSupportForSimplifyBundle(params.devices || []);
    if (!supported)
        return;
    
    const includedObjects = params.sceneObjects || [];
    bundleConfig.instances = {};
    bundleConfig.decals = {};
    bundleConfig.sceneObjects = Object.entries(bundleConfig.sceneObjects).reduce((acc,[key,obj]) => {
        if (key.toLowerCase().match(/onemesh|interior/g) || includedObjects.includes(key)) {
            acc[key] = obj;
        }
        return acc;
    },{});
}

function activateLiteModeForSimplifyBundle () {
    const params = config.resources.bundle.simplifyBundle || {};
    if (!params.active)
        return;
    
    const supported = isDeviceSupportForSimplifyBundle(params.devices || []);
    if (!supported)
        return;
    
    const liteMode = params.liteMode;
    if (!liteMode)
        return;
    
    const DEFAULT = {
        "active": true,
        "debug": false,
        "mode": "regular",
        "oneLabel": {
            "x": 0,
            "y": 0,
            "scale": 1
        },
        "labels": [],
        "settings": {
            "sea": {
                "active": false,
                "path": "",
                "speed": 0.4,
                "opacity": 0.5,
                "scale": 1.9,
                "position": 0.15
            },
            "cars": {
                "active": false,
                "path": "",
                "speed": 0.0012,
                "position": {
                    "x": 0,
                    "y": 0,
                    "z": -1
                },
                "rotation": {
                    "x": 1.57,
                    "y": 0,
                    "z": 0
                },
                "scale": {
                    "x": 1,
                    "y": 1,
                    "z": 1
                }
            },
            "trees": {
                "active": false,
                "path": "",
                "speed": 0.2,
                "turbulence": 0.001,
                "scale": {
                    "x": 50.0,
                    "y": 50.0
                },
                "offsetX": {
                    "x": 100,
                    "y": 0.0
                },
                "offsetY": {
                    "x": 300.0,
                    "y": 150.0
                }
            },
            "sky": {
                "active": false,
                "path": "",
                "direction": 1.57,
                "scale": 2.0,
                "dark": 0.0,
                "light": 0.3,
                "cover": 0.3,
                "alpha": 3.0,
                "tint": 0.9,
                "skySpeed": 0.001,
                "gradient": {
                    "mixingLine": 0.25,
                    "colors": {
                        "day": {
                            "bottom": "#ffffff",
                            "top": "#0078cd"
                        },
                        "night": {
                            "bottom": "#915d2f",
                            "top": "#141675"
                        }
                    }
                },
                "horizon": -0.12,
                "rainbow": {
                    "scale": 1.5,
                    "position": -0.3
                }
            },
            "damping": {
                "active": true,
                "dampingFactor": 0.07
            },
            "zoom": {
                "step": 0.8,
                "initial": 1.01,
                "max": 4,
                "position": {
                    "x": 0,
                    "y": 0
                }
            },
            "edges": {
                "color": "#ffffff"
            }
        },
        "images": {
            "general": "general.jpg",
            "night": "",
            "depth": ""
        },
        "models": [],
        "mapping": ""
    };
    
    config.features.liteMode = assignDeep(DEFAULT,liteMode);
}


function simplifyBundleIsDisabled () {
    const params = config.resources.bundle.simplifyBundle || {};
    if (!params.active)
        return true;
    
    const supported = isDeviceSupportForSimplifyBundle(params.devices || []);
    return !supported;
}
